/** @jsxImportSource @emotion/react */
import { Interpolation, Theme } from '@emotion/react';
import { iconMap, IconName } from '../../icons';

interface Props {
  name: IconName;
  size?: string;
  ariaLabel?: string;
  className?: Interpolation<Theme>;
  testId?: string;
}

export const Icon = ({
  name,
  size = '24px',
  className,
  testId,
  ariaLabel,
}: Props) => {
  return (
    <div
      data-testid={testId}
      aria-label={ariaLabel ? ariaLabel : name}
      css={[
        {
          width: size,
          height: size,
        },
        className,
      ]}
    >
      {iconMap[name]}
    </div>
  );
};
